import { Plus, X, ChevronLeft } from "lucide-react";
import { Button } from "@components/ui/button";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@redux/store";
import { addNACECodes, removeNACECodes } from "@redux/slices/filter";
import { useState } from "react";
import { FilterAtom } from "@/App";
import {useRecoilState } from "recoil";

interface Props {
  handleClose: () => void;
}

const NACEIndustryFilters: React.FC<Props> = ({ handleClose }) => {
  const [searchKeyword, setSearchKeyword] = useState<string>("");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const selectedIndustries =
    useSelector((state: RootState) => state.filter?.industries?.naceCodes) ||
    [];

  const handleKeywordAdd = (keyword: string) => {
    if (keyword && !selectedIndustries.includes(keyword)) {
      dispatch(addNACECodes(keyword));
      setSearchKeyword("");
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      handleKeywordAdd(searchKeyword);
    }
  };

  const handleKeywordRemove = (keyword: string) => {
    if (selectedIndustries.includes(keyword)) {
      dispatch(removeNACECodes(keyword));
    }
  };

  
  const [filter, setFilter] = useRecoilState(FilterAtom);
  const handleClick = (id: string) => {
    console.log("now clicked is " + id);
    // setClickedIds((prevStrings) => [...prevStrings, id]);
    setFilter((prevFilters: string[]) => [...prevFilters, id]); // Append to the atom
    console.log("I am here now");
  };

  return (
    <div className="flex flex-col justify-between h-full p-8">
      <div>
        <div className="flex justify-between items-center mb-5">
          <h4 className="text-xl font-bold flex items-center -ms-2">
            <ChevronLeft
              size={22}
              className="me-3 cursor-pointer"
              onClick={() => navigate(-1)}
            />
            NACE  Codes
          </h4>
          <X onClick={handleClose} className="cursor-pointer" />
        </div>

        <div className="w-8/12">
          <div className="relative mb-8">
            <input
              className="appearance-none placeholder:text-[#B5B7C0] placeholder:text-sm placeholder:ps-1 border-0 pl-10 border-[#e2e8f0] bg-white shadow-sm transition-colors rounded-md w-full py-2 px-3 text-gray-800 leading-tight focus:outline-none"
              type="text"
              placeholder="Search or Add Industry Code"
              value={searchKeyword}
              onChange={(e) => setSearchKeyword(e.target.value)}
              onKeyDown={handleKeyDown}
            />
            <div className="absolute left-0 inset-y-0 flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 ml-3 text-gray-400 hover:text-gray-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="#71717A"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
              </svg>
            </div>
            <div className="absolute right-[10px] inset-y-0 flex items-center">
              <Plus
                className="cursor-pointer"
                onClick={() => handleKeywordAdd(searchKeyword)}
              />
            </div>
          </div>

          <div className="flex flex-wrap gap-4">
            {selectedIndustries.map((industry: string) => (
              <div
                key={industry}
                className="bg-white rounded-lg flex text-sm justify-between border-b w-[48%] px-4 py-2"
              >
                <p>{industry}</p>
                <X
                  onClick={() => handleKeywordRemove(industry)}
                  className="cursor-pointer"
                  size={16}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="flex justify-end mt-4">
        <Button 
        
        onClick={() => {
          handleClick("Industry NACE Codes"); // Replace someValue with the actual value you want to pass
          navigate(-1); // Navigate back
        }}  
        className="bg-[#1CB5AF]">Save</Button>
      </div>
    </div>
  );
};

export default NACEIndustryFilters;
